import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

import useGlobalQueries from '../hooks/useGlobalQueries';

import PublishLocalesModalVersionStatus from './publishLocalesModalVersionStatus';

import styles from '../styles/publishLocalesModal.module.scss';

const PublishLocalesModalSelected = ({
  hasUnpublishedChanges = false,
  isPublished = false,
  locale = null,
  publishedAt = null,
  updatedAt = null,
  status = null,
}) => {
  const { adminSettings } = useGlobalQueries();

  return (
    <>
      <div>
        <Typo element="span" variant="s03" weight="medium">
          {i18n.t('selected-locales-to-publish')}
        </Typo>
      </div>
      <div className={styles.locale}>
        <Typo element="span" variant="s03" weight="medium">
          {adminSettings.data.locales.find(({ key }) => key === locale).name}
        </Typo>
        <PublishLocalesModalVersionStatus
          publishedAt={publishedAt}
          isPublished={isPublished}
          updatedAt={updatedAt}
          status={status}
          hasUnpublishedChanges={hasUnpublishedChanges}
        />
      </div>
    </>
  );
};

PublishLocalesModalSelected.propTypes = {
  hasUnpublishedChanges: PropTypes.bool,
  locale: PropTypes.string,
  isPublished: PropTypes.bool,
  publishedAt: PropTypes.string,
  status: PropTypes.oneOf(['approved', 'editing', 'in_review', 'in_translation', null]),
  updatedAt: PropTypes.string,
};

export default PublishLocalesModalSelected;
